module.exports = __webpack_public_path__ + "img/phone 2.2701ec1d.png";